module.exports = __webpack_public_path__ + "static/gatsby-b7637c262ad964cf2f70abbbfc9e1f93.png";